// extracted by mini-css-extract-plugin
module.exports = {"loading_g":"Loading_g_loading_g__1jRVv"};